<template>
  <div class="rounded-2xl bg-linear-to-br from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-stone-900 ring-1 ring-amber-200/70 dark:ring-amber-900/40 p-6 sm:p-8 text-center">
    <div class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40 ring-1 ring-amber-200 dark:ring-amber-800">
      <UIcon name="i-heroicons-chat-bubble-left-right" class="h-6 w-6 text-amber-600 dark:text-amber-400" />
    </div>
    <h3 class="text-lg font-semibold font-serif text-gray-900 dark:text-gray-100">Can't find what you're looking for?</h3>
    <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">
      Our support team is here to help. Open a ticket and we'll get back to you by email.
    </p>
    <div class="mt-4">
      <UButton to="/tickets/new" color="primary" icon="i-heroicons-plus" size="md">
        Create a support ticket
      </UButton>
    </div>
  </div>
</template>
